import Noty from 'noty'

export default {
  success (text, killer = true) {
    new Noty({
      type: 'success',
      theme: 'bootstrap-v4',
      text: text,
      timeout: 3000,
      layout: 'bottomRight',
      progressBar: false,
      killer: killer
    }).show()
  },
  error (text) {
    new Noty({
      type: 'error',
      theme: 'bootstrap-v4',
      text: text,
      timeout: 3000,
      layout: 'bottomRight',
      progressBar: false
    }).show()
  },
  warning (text) {
    new Noty({
      type: 'warning',
      theme: 'bootstrap-v4',
      text: text,
      timeout: 3000,
      layout: 'bottomRight',
      progressBar: false
    }).show()
  }
}



// WEBPACK FOOTER //
// ./src/message.js